import { useQueryClient } from '@tanstack/react-query'
import { Button, Flex, Form, Input, Modal, ModalProps } from 'antd'

import { useInvestigationsServiceGetInvestigationTestEndpointKey } from 'src/api/queries'
import { useInvestigationsServiceRejectInvestigationTestEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests/core/ApiError'
import { requiredRules } from 'src/app-constants'
import { message } from 'src/components'
import { useLocales } from 'src/locales'
import { formErrorHandler } from 'src/utils'

type Props = {
  id?: string
  onCancel: () => void
} & ModalProps

export const RejectTestResultModal = ({ onCancel, id, ...props }: Props) => {
  const { t } = useLocales()

  const queryClient = useQueryClient()

  const [form] = Form.useForm()

  const { mutate: reject } =
    useInvestigationsServiceRejectInvestigationTestEndpoint({
      onSuccess: () => {
        message.success(t('investigations.successfully_rejected_test'))
        queryClient.invalidateQueries({
          queryKey: [useInvestigationsServiceGetInvestigationTestEndpointKey]
        })
        onCancel()
      },
      onError: (err: ApiError) => formErrorHandler(err.body.errors)
    })

  const onSubmit = () => {
    const values = form.getFieldsValue(true)
    reject({
      id: String(id),
      requestBody: {
        reason: values.reason
      }
    })
  }

  return (
    <Modal
      {...props}
      open
      maskClosable={false}
      onCancel={onCancel}
      centered
      footer={null}
      title={t('investigations.reject_test_result')}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <Flex vertical gap={24}>
          <Form.Item
            name="reason"
            label={t('investigations.reject_reason')}
            rules={requiredRules}
          >
            <Input.TextArea />
          </Form.Item>

          <Flex justify="center" gap={16}>
            <Button onClick={onCancel}>{t('common.cancel')}</Button>
            <Button type="primary" onClick={onSubmit}>
              {t('common.save')}
            </Button>
          </Flex>
        </Flex>
      </Form>
    </Modal>
  )
}
